<script setup>

import {storeToRefs} from "pinia";
import {useOrdersStore} from "@/stores/order.store";
import {useRoute} from "vue-router/dist/vue-router";
import {onMounted, ref} from 'vue'
import {useRouter} from "vue-router";
import useDebounce from "@/helpers/debouncer";
import {useProductStore} from "@/stores/product.store";

const route = useRoute();
const router = useRouter();

const productStore = useProductStore();
const {product} = storeToRefs(productStore);

const ordersStore = useOrdersStore();
const totalPrice = ref(0);

onMounted(async () => {
    await productStore.fetchOne(route.params.id);
    totalPrice.value = product.value.amount * 100;
});

const createOrder = async () => {
    useDebounce(await ordersStore.create(route.params.id));
}

</script>

<template>
    <van-space direction="vertical" fill>
        <van-row justify="center">
            <van-image
                :src="product.thumbnail_file_absolute_path"
                fit="contain"
            />
        </van-row>
        <div style="margin: 20px">
            <h3>
                {{ product.name }}
            </h3>
            <div>
                {{ product.description }}
            </div>
        </div>

        <van-row>&nbsp;</van-row>

        <div v-if="product.treatment_plan">
            <van-cell-group inset>
                <div class="van-ellipsis"><b>{{product.treatment_plan.name}}</b></div>
            </van-cell-group>
            <van-row>&nbsp;</van-row>
            <van-cell-group inset>
                <van-cell v-for="session in product.treatment_plan.treatment_sessions" :key="session.id">
                    <template #title>
                        {{session.name}}
                    </template>
                    <template #label>
                        {{session.description}}
                    </template>
                </van-cell>
            </van-cell-group>
        </div>
        <van-row>&nbsp;</van-row>

        <van-submit-bar label="Total" currency="$" :price="totalPrice" button-text="Buy Now" @submit="createOrder">
            <van-action-bar-icon icon="home-o" text="Home" @click="router.push('/')"/>
        </van-submit-bar>
    </van-space>
</template>
